export type BankStatementFields = {
  accountNumber?: string | null;
  bsb?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
};

const hasText = (value?: string | null) => Boolean(value?.trim());

// Matches InspectionFileBankStatement.hasRequiredFields: address, account number, and BSB.
export const hasRequiredBankStatementFields = (
  bankStatement?: BankStatementFields | null
) => {
  if (!bankStatement) {
    return false;
  }

  const address = [bankStatement.addressLine1, bankStatement.addressLine2]
    .filter(hasText)
    .join(', ');

  return (
    hasText(address) &&
    hasText(bankStatement.accountNumber) &&
    hasText(bankStatement.bsb)
  );
};
